
export default {

    computed: {
        userInfo() {
            return this.$store.state.settings.userInfo
        },


        hasPhone() {
            return !!this.userInfo.contacts.phone
        },
        hasEmail() {
            return !!this.userInfo.contacts.email
        },
    },
    methods: {
        changeSettings(settingName, newValue) {
            return this.$store.dispatch('settings/SET_SETTING', {
                    settingName,
                    newValue
                })
                .catch(error => {
                    this.$eventBus.$emit('error', error)
                })
        }
    }
}